module.exports = __webpack_public_path__ + "img/colored-paper-4.2fa9de4e.png";